<template>
  <div>
    <h6 class="mt-3">{{ $t('Añadir producto por referencia o por nombre') }}</h6>
    <div class="table_desc">
      <div class="cart_page">              
        <table>
          <thead>
            <tr>
              <th width="30">#</th>
              <th width="70">Ref</th>
              <th width="71">Img</th>
              <th>{{ $t('Producto') }}</th>
              <th width="80" class="unitspp">{{ $t('Unidades por bolsa') }}</th>
              <th width="100" class="unitspp">{{ $t('Precio por unidad') }}</th>
              <th width="61"></th>                      
              <th width="75" class="unitspp">{{ $t('Unidades') }}</th>              
              <th width="115"></th>
              <th width="150"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="p-0">
                <img v-if=" searchLoading " :src=" getBaseUrl + '/assets-own/images/loading-rainbow-bg-w.svg' " width="20" height="20" alt="Spinning">
              </td>
              <td>
                <input 
                  v-model="searchRefValue"                           
                  @focus=" setFocus('focusRef') "
                  v-focus="focusRef"
                  @keyup.enter="searchRef"                         
                  type="text"
                  maxlength="5"
                  class="refInput"
                >
              </td>
              <td>
                <img v-if=" searchSelected.ref_image " :src=" getBaseUrl + getImgUrl + searchSelected.ref_image " class="product_thumb">
              </td>
              <td>
                <auto-complete 
                  v-model="searchNameSelected" 
                  :items="filteredSearchNameResults" 
                  :get-label="getLabel" 
                  :component-item="searchNameTemplate"
                  @update-items="updateSearchItems"
                  :auto-select-one-item="false"
                  :min-len="0"
                  @item-selected="setFocus('focusQuantity')"
                  @focus=" setFocus('focusName') "
                  ref="autocomplete"
                  @change="onChangeSearchName"
                  class="autocomplete"
                ></auto-complete>
                <!-- @focus=" setFocus('focusName') " -->
              </td>
              <td>
                <template v-if=" searchSelected ">
                  {{ searchSelected.ref_unitspp }}
                </template>
              </td>
              <td class="text-right black">
                <template v-if=" searchSelected ">
                  <span v-if=" searchSelected.ref_price > 0">{{ toCurrency(searchSelected.ref_price) }}</span>
                  <span v-else>{{ $t('consultar') }}</span>
                </template>
              </td>  
              <td></td>            
              <td>
                <input 
                  v-if="searchSelected.ref_price > 0"
                  v-model="addQuantity"
                  v-focus="focusQuantity"
                  @keyup.enter="addSearchedItem"
                  type="number" min="0" class="text-right"
                >
              </td>
              <td class="text-left">
                <button 
                  v-if="searchSelected.ref_price > 0"
                  @click.prevent=" addSearchedItem " 
                  class="btn-biv c-bg-grey-blue"><i class="fa fa-plus-circle"></i>
                </button>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Añadir producto por referencia o por nombre": "Añadir producto por referencia o por nombre",
    "Producto": "Producto",
    "Unidades por bolsa": "Unidades por bolsa",
    "Precio por unidad": "Precio por unidad",
    "Unidades": "Unidades",
    "La referencia no existe!": "La referencia no existe!",
    "Tiene que añadir como mínimo una unidad al carrito!": "Tiene que añadir como mínimo una unidad al carrito!",
    "Error": "Error",
    "consultar": "consultar"
  },
  "en": {
    "Añadir producto por referencia o por nombre": "Add product by reference or by name",
    "Producto": "Product",
    "Unidades por bolsa": "Units per bag",
    "Precio por unidad": "Price per unit",
    "Unidades": "Units",
    "La referencia no existe!": "Reference does not exist!",
    "Tiene que añadir como mínimo una unidad al carrito!": "You have to add at least one unit to the cart!",
    "Error": "Error",
    "consultar": "ask"
  }
}
</i18n>

<script>
  import { mixin as focusMixin }  from 'vue-focus';

  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import { mixinGlobal } from './../../mixins/mixinGlobal';

  import AutoComplete from './autocomplete/Autocomplete.vue'
  import SearchNameResultsTemplate from './SearchNameResultsTemplate.vue'

  export default {
    mixins: [ mixinGlobal, focusMixin ],
    components: { AutoComplete },
    data: () => {
      return {
        cancelToken: '',
        timeout: null,
        searchSelected: 0,
        searchLoading: false,
        searchRefValue: null,
        searchNameValue: null,
        searchNameSelected: null,
        searchNameResults: null,
        searchNameResultsLength: 8,
        searchNameTemplate: SearchNameResultsTemplate,
        focusQuantity: false,
        focusName: false,
        focusRef: false,
        addQuantity: ''
      }
    },
    computed: {
      ...mapGetters(['getBaseUrl', 'getApiUrl', 'getImgUrl']),
      filteredSearchNameResults (){
        return this.searchNameResults ? this.searchNameResults.slice(0,this.searchNameResultsLength) : null
      }
    },
    methods: { 
      ...mapMutations(['mutateGlobalMessage']),
      ...mapActions(['addItemShoppingCart']),
      getLabel (item) {
        return item = item ? item.ref_description : ''
      },
      updateSearchItems (text) {
        if (text.length > 0) {          
          clearTimeout(this.timeout);
          this.searchLoading = true

          this.timeout = setTimeout(function() {
            if(this.cancelToken!='' && this.source!=''){
              this.source.cancel();   
            }
            this.cancelToken = this.$axios.CancelToken;
            this.source = this.cancelToken.source();

            this.$axios.get( this.getApiUrl + 'buscador.php?buscar='+text+'&en=ref_description', {cancelToken: this.source.token}).then(response => {
                this.searchNameResults = response.data
                //console.log(response)
                this.searchLoading = false
                
            }).catch((thrown) => {
              if (this.$axios.isCancel(thrown)) {
                //console.log('Request canceled');
              } else {
                this.searchNameResults = null;
              }
              this.searchLoading = false
            });

          }.bind(this), 300);
        }else{
          this.searchNameResults = null
        }
      },
      setFocus(itemToFocus){
        switch(itemToFocus){
          case ('focusQuantity'):
            if( this.searchSelected.hasOwnProperty('ref_price') ){
              if( this.searchSelected.ref_price > 0 ){               
                this.focusRef = false
                this.focusName = false
                this.focusQuantity = true;  
              }
            }
            break;            
          case ('focusRef'): 
            this.focusQuantity = false; 
            this.focusName = false
            this.focusRef = true; 
            break;
          case ('focusName'): 
            this.focusQuantity = false;             
            this.focusRef = false; 
            this.focusName = true
            break;
        }
      },
      searchRef(){
        if( this.searchRefValue ){
          this.searchLoading = true
          this.$axios.get( this.getApiUrl + 'buscador.php?buscar=' + this.searchRefValue + '&en=ref_number')
          .then(response => {
            if ( response.data.length == 0 ){    
              this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message: this.$t('La referencia no existe!') } )	  
              this.searchSelected = 0
              this.addQuantity = ''  
              this.searchNameSelected = null
              
            }else{
              this.searchSelected = this.searchNameSelected = response.data[0]
              if(this.searchSelected.ref_price == 0){
                this.setFocus('focusRef')
              }else{
                this.setFocus('focusQuantity') 
              }           
            }
            this.searchLoading = false              
          }).catch((error) => {
            console.log(error)                
          });
        }
      },
      addSearchedItem(){
        if( this.addQuantity < 1 ){
          this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message: this.$t('Tiene que añadir como mínimo una unidad al carrito!') } )	
          this.setFocus('focusQuantity') 				
				}else{
          this.searchSelected.updateValue = this.addQuantity
          this.$store.dispatch('addItemShoppingCart', this.searchSelected)
          .then(response => {
            this.searchNameSelected = 0
            this.searchSelected = 0
            this.searchRefValue = ''
            this.addQuantity = ''
            this.searchNameResults = null   
            this.setFocus('focusRef')
          }, error => {
              console.error("Got nothing from server. Prompt user to check internet connection and try again")
          })
          
				}
      },
      onChangeSearchName(queryString){
        this.$nextTick(() => {
          this.$refs.autocomplete.searchText = queryString;
        });
      }
    },
    watch: {
      searchNameSelected: function(val){
        this.searchSelected = val ? val : 0
        this.searchRefValue = val ? val.ref_number : this.searchRefValue
        this.addQuantity = ''

        if( typeof (val) == 'object' && val !== null ){
          if( val.hasOwnProperty('ref_price') ){
            if( val.ref_price > 0 ){
              this.focusRef = false
              this.focusName = false
              this.focusQuantity = true;
            }
          }
        }
      }
    },
  }
</script>
<style>
  .autocomplete{
    z-index: 2;
  }
  .reference .v-autocomplete-input-group .v-autocomplete-input {
    padding: 10px 10px !important;
  }
  .refInput{
    padding-left: 0px;
    text-align: center
  }

  .v-autocomplete{
  position:relative;
}
.v-autocomplete .v-autocomplete-list{
  position:absolute;
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item{
  cursor:pointer;
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item.v-autocomplete-item-active{
  background-color:#DADFF7 !important;
}
.v-autocomplete .v-autocomplete-input-group .v-autocomplete-input {
  font-size: 14px;
  padding: 10px 14px;
  box-shadow: none;
  border: 1px solid #BBB;
  width: 100%;
  outline: none;
  background-color: #eceff8;
  height: 45px;
}
.v-autocomplete .v-autocomplete-input-group.v-autocomplete-selected .v-autocomplete-input {
  color: #626262;
  background-color: #eceff8;
}
.v-autocomplete .v-autocomplete-list {
  width: 100%;
  text-align: left;
  border: none;
  border-top: none;
  /* max-height: 350px; */
  max-height: auto !important;
  overflow-y: auto;
  border-bottom: 1px solid #BBB;
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item {
  font-size: 12px;
  cursor: pointer;
  background-color: #eceff8;
  padding: 3px 10px;
  border-bottom: 1px solid #BBB;
  border-left: 1px solid #BBB;
  border-right: 1px solid #BBB;
}
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item:last-child {
  border-bottom: none;
}

.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item:hover {
  background-color: #DADFF7 !important;
}
</style>